























import { Upload } from "tus-js-client";
import { TranslateResult } from "vue-i18n";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import MaltaModule, { MODULE_ID } from "../../../index";

export type TusFile = {
    id: string;
    src: string;
    filename: string;
    type?: string;
    fileId?: number;
    file?: File;
    uploader?: Upload;
    width?: number;
    height?: number;
    success: boolean;
    progress: boolean;
    paused: boolean;
};

@Component
export default class TusButton extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Prop({ type: Number, required: true }) index!: number;
    @Prop({ type: Object, required: true }) file!: TusFile;

    onProgress = false;
    onComplete = false;
    paused = false;
    bytesSent = 0;
    bytesTotal = 0;

    get percents() {
        if (this.bytesTotal > 0) {
            return ((this.bytesSent / this.bytesTotal) * 100).toFixed(1);
        }

        return "0";
    }

    get absoluteUrl() {
        const { protocol, host } = location;
        const url: string[] = [];
        url.push(protocol);
        url.push("//");
        url.push(host);
        return url.join("");
    }

    mounted() {
        if (this.file.uploader) {
            this.file.uploader.options.onSuccess = () => {
                this.onProgress = false;
                this.onComplete = true;
                this.file.progress = false;
                this.file.paused = false;
                this.file.success = true;
                if (this.file.uploader) {
                    this.$emit("fileSuccess", `${this.absoluteUrl}${this.file.uploader.url}`);
                }
            };
            this.file.uploader.options.onProgress = (bytesSent: number, bytesTotal: number) => {
                this.onProgress = true;
                this.file.progress = true;
                this.file.paused = false;
                this.file.success = false;
                this.bytesSent = bytesSent;
                this.bytesTotal = bytesTotal;
                this.$emit("fileProgress", bytesSent, bytesTotal);
            };
        }
    }

    deleteFile() {
        if(this.file.uploader){
            this.file.uploader.abort(true);
            this.$emit("fileDeleted", this.index, `${this.absoluteUrl}${this.file.uploader.url}`);
        } else {
            this.$emit("fileDeleted", this.index);
        }
    }

    pauseFile() {
        this.paused = true;
        this.file.paused = true;
        this.file.uploader?.abort();
    }

    playFile() {
        this.paused = false;
        this.file.paused = false;
        this.file.uploader?.start();
    }

    cancelFile() {
        if(this.file.uploader){
            this.file.uploader.abort(true);
            this.$emit("fileDeleted", this.index, `${this.absoluteUrl}${this.file.uploader.url}`);
        } else {

            this.$emit("fileDeleted", this.index);
        }
    }
}
